import script from "./DeclinedApp.vue?vue&type=script&setup=true&lang=js"
export * from "./DeclinedApp.vue?vue&type=script&setup=true&lang=js"

import "./DeclinedApp.vue?vue&type=style&index=0&id=5d4a21fa&lang=css"

const __exports__ = script;

export default __exports__